import { HomeExamPaperPackage } from './HomeExamPaperPackage';
export default HomeExamPaperPackage;
